<template>
  <div class="app" :class="mode">
    <Navbar :mode="mode" @toggle="toggle" />
    <NprogressContainer />
    <notifications group="theme" position="bottom left" closeOnClick />
    <transition name="fade" mode="out-in">
      <router-view />
      <slot />
    </transition>
    <Footer />
  </div>
</template>

<script>
import NprogressContainer from "vue-nprogress/src/NprogressContainer";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default {
  name: "App",
  data() {
    return {
      mode: "light"
    };
  },
  components: {
    Footer,
    Navbar,
    NprogressContainer
  },
  created() {
    window.addEventListener("keyup", this.keyPress);
  },
  methods: {
    keyPress(e) {
      if (e.key === "t") {
        this.toggle();
      }
    },
    toggle() {
      if (this.mode === "dark") {
        this.mode = "light";
        this.$notify({
          group: "theme",
          type: "success",
          title: "Theme changed",
          text: `${this.mode} theme activated`
        });
      } else {
        this.mode = "dark";
        this.$notify({
          group: "theme",
          title: "Theme changed",
          text: `${this.mode} theme activated`
        });
      }
    }
  },
  mounted() {
    // console.log("App Mounted");
    if (localStorage.getItem("mode")) {
      this.mode = JSON.parse(localStorage.getItem("mode"));
    }
  },
  watch: {
    mode: {
      handler() {
        // console.log("Theme mode changed");
        localStorage.setItem("mode", JSON.stringify(this.mode));
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
@import "./assets/css/base.scss";

.app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  transition: all 0.3s ease-in-out;
}

// Dark Mode Style
.dark {
  background: #192734;
  color: #fff;

  a {
    color: turquoise;
  }

  .navbar {
    .navbar-nav {
      @media all and (max-width: 720px) {
        background-color: #2c3e50 !important;
      }
    }

    .nav-link {
      color: #fff;
    }

    .navbar-brand {
      color: #fff;

      &:hover {
        color: #1f1f1f;
      }
    }

    .navbar-toggler {
      background-color: $first-color;
    }

    .nav-link.router-link-exact-active {
      color: $first-color;
    }
  }

  .theme-mode {
    background-color: $first-color;
    color: #2c3e50;
  }

  .bg-hero {
    background-color: #2c3e50 !important;
  }

  .projects_section {
    h2 {
      color: #fff !important;
    }
  }

  .contact-section {
    background-color: #2c3e50 !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
